import qsa from "1dr-utils/helpers/elsForEach";
import onClick from "@/js/libs/onClick";
import getParents from "@/js/libs/getParents";
import initContinue from "@/js/parts/checkout/continueCheckout";

let APP = window.APP || {};

export default function () {
  let continueCallback = function (json) {
    // This should be an edge case response, so we can use our modal
    // for the edge cases....
    if (json.error) {
      APP.showModal(json.error);
      CamperForm.states.ready();
      return;
    }

    window.location =
      CamperForm.formData.get("redirect") || window.location.href;
  };

  let CamperForm = initContinue("camper-details-form", continueCallback);

  if (!CamperForm) {
    return;
  }

  // Primary contact copy handling
  qsa("[name=copy-details]", (c) => {
    c.onchange = function (e) {
      let select = e.target;
      let fields = select.dataset.fields; // Form fields name prefix
      if(select.value) {
        // Get contact details from camper data set in _checkout/farm-camp/camper-details.twig
        let contact = window.contacts[e.target.value - 1].primaryContact;
        // Copy contact details to field values
        Object.keys(contact).forEach(key => {
          let fieldName = `${fields}[${key}]`;
          let input = document.querySelector(`[name="${fieldName}"]`);
          input.value = contact[key];
        });
      }
      else {
        // Empty fields if no camper chosen
        qsa(`.primary-contact [name^="${fields}"]`, input => {
          input.value = null;
        });
      }
    };
  });

  onClick("[data-expand-concertina]", function () {
    this.blur();
    let id = this.getAttribute("aria-controls");
    let concertina = document.getElementById(id);
    if (!concertina) {
      return;
    }
    let toggled =
      concertina.getAttribute("aria-expanded") == "true" ? "false" : "true";
    concertina.setAttribute("aria-expanded", toggled);
    this.setAttribute("aria-pressed", toggled);
  });

  let newCamperContainer = document.getElementById("new-camper-container");

  onClick("[data-edit]", function (e) {
    let containingForm = getParents(this, "form");

    if (!containingForm) {
      console.warn("no containing form");
      return;
    } else {
      containingForm = containingForm[0];
    }

    let id = this.getAttribute("data-edit");

    let fieldset = document.getElementById(id);

    if (fieldset) {
      e.preventDefault();
      this.blur();

      let wasDisabled = fieldset.hasAttribute("disabled");

      // Close everything...
      let fieldSets = containingForm.querySelectorAll("[data-camper-fieldset]");
      qsa(fieldSets, (f) => {
        f.setAttribute("disabled", true);
      });

      // Toggle this one:
      if (wasDisabled) {
        fieldset.removeAttribute("disabled");
        let firstInput = fieldset.querySelector(
          'input:not([type="hidden"]), select, textarea',
        );
        if (firstInput) {
          firstInput.focus();
        }

        if (id != "camper-form-new" && newCamperContainer) {
          newCamperContainer.style.display = "none";
        }
      } else {
        newCamperContainer.style.display = "";
      }
    }
  });

  CamperForm.onSubmitClick(function (el, e) {
    let id = el.getAttribute("data-remove-camper");

    if (!id) {
      return;
    }

    let containingGroup = document.getElementById(id);
    let containingForm = getParents(el, "form");

    if (!containingGroup) {
      console.warn("no containing group");
      return;
    }

    if (!containingForm) {
      console.warn("no containing form");
      return;
    } else {
      containingForm = containingForm[0];
    }

    e.preventDefault();
    CamperForm.states.loading();

    // Disable everything in this group, and submit the page. The result
    // should be a save of all campers, but without this row enabled, it'll be considered
    // out of the matrix
    let toDisable = containingGroup.querySelectorAll(
      "input, select, button, textarea",
    );

    qsa(toDisable, (el) => {
      el.setAttribute("disabled", true);
    });

    // pass true to clear.
    this.updateFormValues(true);
    // Ensure this comes after the values update.
    this.formData.set("action", el.getAttribute("value"));

    // See how many campers we have...
    let camperIds = [];
    qsa("[data-camper-group]", (camper) => {
      camperIds.push(camper.id);
    });
    // If it's only 1, and it's _this_ one, then set an empty
    // field[camperDetails] so that the matrix is set to 0 rows
    // and we then kill the line items too.
    if (camperIds.length === 1 && camperIds[0] === id) {
      this.formData.set("fields[camperDetails][" + id + "][type]", "null");
    }

    this.post(
      (json) => {
        continueCallback(json);
      },
      false,
      function () {
        CamperForm.states.ready();
      },
    );
  });
}
